export default "__VITE_ASSET__qyxaiM5i__"